import request from "@/utils/request";

// 列表(主数据列表)
export function loadExpenseLoanListListDataApi(data) {
  return request({
    url: "web/expenseLoanList/listData",
    method: "post",
    data
  });
}
// 导出
export function loadExpenseLoanListExportDataApi(data) {
  return request({
    url: "web/expenseLoanList/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateExpenseLoanListApi(data) {
  return request({
    url: "web/expenseLoanList/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initExpenseLoanListApi(data) {
  return request({
    url: "web/expenseLoanList/init",
    method: "post",
    data
  });
}

// 获取下拉列表
export function getExpenseLoanListListApi(data) {
  return request({
      url: "web/expenseLoanList/listSelectData",
      method: "post",
      data
  });
}

// 获取借款合计
export function findLoanAmountTotalByUserIdApi(data) {
  return request({
      url: "web/expenseLoanList/findLoanAmountTotalByUserId",
      method: "post",
      data
  });
}